<template>
    <div class="card">
        <div class="left">
            <img class="image" :src="imgPath" alt="product-image">
        </div>
        <div class="right">
            <h1>{{ name }}</h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus adipisci, doloremque sapiente veritatis dolorum officia quasi asperiores placeat nemo et quis, enim accusantium, dignissimos eveniet neque labore perspiciatis nostrum? Ducimus?</p>
            <div v-if="type != 3" class="months">
                <button class="month-btn" @click="remove">-</button>
                <div>{{ months }} {{months == 1 ? "month" : "months"}}</div>
                <button class="month-btn" @click="add">+</button>
                <h2>${{ price }} / month</h2>
            </div>
            <div class="bottom">
                <div class="total">
                    <div class="final" v-if="total != 0">Total: ${{ total }}</div>
                    <div class="final" v-else>Total: ${{ price }}</div>
                    <button class="purchase-btn">Purchase</button>
                </div>
                <div class="carbon">
                    <p class="saving">You are saving</p>
                    <div class="row">
                        <p class="kilos">203</p>
                        <p class="co">kg of CO2</p>
                        <img class="leaf" src="../assets/leaf.svg" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="close" @click="close">&cross;</div>
    </div>
</template>

<script>

export default {
  name: 'PurchasePage',
  data() {
    return {
        months: 1,
        total: 0,
    }
  },
  props: {
    imgPath: String,
    name: String,
    price: Number,
    type: Number,
  },
  methods: {
    add() {
        this.months += 1;
        this.total = this.price * this.months;
    },
    remove() {
        if (this.months > 1) {
            this.months -= 1;
        }
        this.total = this.price * this.months;
    },
    close() {
        this.$emit('closeModal', 'false');
    }
  }
}
</script>

<style scoped>
.row {
    display: flex;
    align-items: center
}

.final {
    margin-top: 10px;
    font-size: 20px;
}

.card {
    background-color: white;
    border: 1px solid black;
    width: 1500px;
    height: 700px;
    position: absolute;
    border-radius: 1.5em;
    left: 0;
    right: 0;
    top: 20%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

.left {
    width: 50%;
    display: flex;
}

.right {
    width: 50%;
    height: 60%;
    display: flex;
    flex-direction: column;
}

.right > p {
    width: 70%;
    color: rgb(90, 90, 90);
}

.bottom {
    display: flex;
}

.image {
    width: 100%;
    height: auto;
}

.months {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 50%;
}

.purchase-btn {
    margin-top: 1em;
    border: none;
    background-color: rgb(81, 201, 131);
    padding: 10px 50px;
    color: white;
    cursor: pointer;
    border-radius: 0.5em;
    font-size: 16px;
    transition: all 0.25s;
    font-weight: 600;
}

.purchase-btn:hover {
    background-color: rgb(91, 91, 91);
}

.month-btn {
    background-color: rgb(81, 201, 131);
    color: white;
    font-size: 16px;
    cursor: pointer;
    border: none;
    border-radius: 1em;
    width: 35px;
    height: 35px;
    transition: all 0.25s;
    font-weight: bolder;
}

.month-btn:hover {
    background-color: rgb(91, 91, 91);
}

.close {
    position: absolute;
    top: 2%;
    left: 97%;
    font-size: 30px;
    cursor: pointer;
    transition: all 0.25s;
}

.close:hover {
    color: rgb(81, 201, 131);
}

.carbon {
    background-color: rgb(81, 201, 131);
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    border-radius: 1em;
    margin-left: 2em;
}

.leaf {
    width: 20px;
    height: auto;
    margin-left: 10px;
}

.kilos {
    font-size: 40px;
    margin: 0;
    font-weight: 900;
}

.saving {
    margin: 0;
    font-weight: 600;
}

.co {
    font-weight: 600;
}
</style>
